<template>
  <common-layout-history-template :isBread="true" :breadHeading="'検索履歴'">
    <template v-slot:body>
      <search-history-contents v-if="searchHistoryReady" />
    </template>
  </common-layout-history-template>
</template>

<script>
import SearchHistoryContents from '@/components/history/search/SearchHistoryContents';
import CommonLayoutHistoryTemplate from '@/components/templates/CommonLayoutHistoryTemplate';

const canonical = location.href.match(/\/$/) === null ? `${location.href}/` : location.href;

export default {
  name: 'SearchHistory',
  components: {
    SearchHistoryContents,
    CommonLayoutHistoryTemplate,
  },
  data() {
    return {

    };
  },
  metaInfo() {
    return {
      link: [
        { rel: 'canonical', href: canonical },
      ],
    };
  },
  computed: {
    searchHistoryReady() {
      return this.$store.getters['getSearchHistory'].data;
    },
  },
  created() {

  },
  methods: {

  },
};
</script>

<!-- Add 'scoped' attribute to limit CSS to this component only -->
<style scoped lang="scss">
@charset "UTF-8";
</style>
